import { Price, SkeletonLoader, Text } from '@kanda-libs/ks-design-library';
import type { FinanceRate } from '@kanda-libs/ks-frontend-services';
import OptionPopover from '../OptionPopover';
import RateCostPopover from './RateCostPopover';
import useFinanceOptionRateCosts from './useFinanceOptionRateCosts';

export interface FinanceOptionsRateDetailsRateCostsProps {
  rates: FinanceRate[];
}

const FinanceOptionsRateDetailsRateCosts: React.FunctionComponent<FinanceOptionsRateDetailsRateCostsProps> =
  function ({ rates }) {
    const { from, cost, popoverId, isLoading, ...rest } =
      useFinanceOptionRateCosts(rates);
    return (
      <>
        <div className="flex flex-row items-center">
          <Price
            amount={from}
            color="lavender-200"
            poundsClassName="text-12-18-em"
            centsClassName="text-12-18-em"
            isLoading={isLoading}
          />
          <Text
            className="ml-1 text-12-18-em text-lavender-200"
            text="/ MO"
            isLoading={isLoading}
          />
        </div>
        <div className="flex flex-row items-center">
          <Price
            amount={cost}
            color="neutral-600"
            poundsClassName="text-12-18-em"
            centsClassName="text-12-18-em"
            wrapperClassName="mr-auto"
            isLoading={isLoading}
          />
          <SkeletonLoader
            isLoading={isLoading}
            className="w-3 h-3 min-w-3"
            afterLoading={
              <OptionPopover popoverId={popoverId}>
                <RateCostPopover {...rest} />
              </OptionPopover>
            }
          />
        </div>
      </>
    );
  };

export default FinanceOptionsRateDetailsRateCosts;
